import React from 'react';
import styled from 'styled-components/macro';
import { Transition } from 'react-transition-group';


const speeds = {
    normal: 450,
    fast:   250,
    slow:   800,
};


const FadeInOutTransition = ({ children, speed = 'normal', ...props }) => (
    <Transition {...props} timeout={speeds[speed] || speed} unmountOnExit mountOnEnter>
        {(state) => (
            <Animation state={state} duration={speeds[speed] || speed}>
                {children}
            </Animation>
        )}
    </Transition>
);


export default FadeInOutTransition;


const Animation = styled.div`
    transition-property: opacity;
    transition-duration: ${(props) => props.duration}ms;
    transition-timing-function: ease-in;
    
    opacity: ${(props) => (props.state === 'entered' ? 1 : 0)};
`;
